/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeServiceTimesPricing {
    angular.module("meevo.plugins.employeeServiceTimesPricing", []);
}